export default __webpack_public_path__ + "static/media/1.f8c521d9.svg";